import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import Loading from '../../components/layouts/Loading'
import { Col, Container, Row } from 'react-bootstrap';
import PageHeader from '../../components/pageHeader/pageHeader.component';
import PhotoGallery from '../../components/photoGallery/photoGallery.component';
import VideoGalleryPageCover from '../../assets/images/banners/video-album.png';

import { videos } from "../../data/videos";
import VideoBlock from '../../components/videoBlock/videoBlock.component';

const VideoAlbumPage = props => {

    const { albumId } = useParams()
    const { loading, videoAlbums } = useSelector(state => state.all)

    const [album, setAlbum] = useState()

    useEffect(() => {
        setAlbum(videoAlbums && videoAlbums.find(item => item._id === albumId))
    }, [videoAlbums, albumId])


    return (
        <div>
            <PageHeader
                title="অ্যালবাম ১"
                cover={VideoGalleryPageCover}
            >
                <p>
                    {album && album.description}
                </p>
            </PageHeader>
            <section className="video-album-section py-5 border-top border-bottom bg-light">
                <Container>
                    {loading ? <Loading /> : (
                        <Row className="mb-5">
                            {
                                album && album.videos.map(video => {
                                    return (
                                        <Col xs={12} md={4} className="mb-4">
                                            <VideoBlock video={video} />
                                        </Col>
                                    )
                                })
                            }
                        </Row>
                    )}
                </Container>
            </section>
        </div>
    )
}

export default VideoAlbumPage;